import { render } from "./DcHeros.vue?vue&type=template&id=52460d57&bindings={\"dcHeros\":\"setup\",\"newHero\":\"setup\",\"remove\":\"setup\",\"addHero\":\"setup\",\"newHeroRef\":\"setup\",\"herosCount\":\"setup\"}"
import script from "./DcHeros.vue?vue&type=script&lang=js"
export * from "./DcHeros.vue?vue&type=script&lang=js"
script.render = render

export default script